<template>
  <div>
    <b-badge style="font-size: 100%;color:blue;" @click="viewBRFDetails(booking_id, prbr_id)"><b>View BRF Booking
        Log</b></b-badge>
    <div :id="'row' + booking_id">
      <md-switch :id="'approval' + booking_id" name="approval" class="md-primary" :value="isbookingactive == 1"
        @change="toggleStatus(prbr_id, prbr_is_active, booking_id, isbookingactive, request_type)">
        <h6>
          <br />
          <b-badge style="margin-left: -45px">
            {{ isbookingactive == 1 ? "Active" : "In-Active" }}
          </b-badge>
        </h6>
      </md-switch>
      <!-- <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm> -->
    </div>
    <b-modal id="viewBRFDetails-modal" ref="viewBRFDetails-modal"
      :title="'BRF Details-' + brf_no + ' Booking No -' + booking_no" size="xl" no-close-on-esc no-close-on-backdrop
      hide-footer>
      <b-row>
        <b-col md="12">
          <b-table :items="BrfBookingList" :fields="BrfBookingColumn" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.item.SN }}</span></template>
          </b-table>
        </b-col>
      </b-row>
      <b-button @click="hideviewBRFDetails" variant="danger" class="pull-right btn-sm mt-2">
        Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
  data() {
    return {
      alert: {
        content: "",
        ok: "OK",
      },
      BrfBookingList: [],
      BrfBookingColumn: [
        { key: 'SN', label: 'SN' },
        { key: 'log_request_type', label: 'Request Type' },
        { key: 'booking_no', label: 'Booking No' },
        { key: 'contract_no', label: 'Contract No' },
        { key: 'enquiry_booking_no', label: 'BRF No' },
        { key: 'enquiry_no', label: 'BRF Enq No' },
        { key: 'log_active_type', label: 'Activity' },
        { key: 'employeeName', label: 'User' },
        { key: 'log_created_at', label: 'Date' }
      ],

      isLoading: false,
    };
  },
  props: {
    brf_no: String,
    booking_no: String,
    booking_id: Number,
    prbr_id: Number,
    isbookingactive: Number,
    prbr_is_active: Number,
    request_type: String
  },
  methods: {
    viewBRFDetails(booking_id, prbr_id) {
      this.getBRFBookingLogDetails(booking_id, prbr_id);
      this.$refs["viewBRFDetails-modal"].show();
    },
    hideviewBRFDetails() {
      this.$refs["viewBRFDetails-modal"].hide();
    },
    getBRFBookingLogDetails(booking_id, prbr_id) {
      let payload = {
        fk_booking_id: booking_id,
        fk_prbr_id: prbr_id,
        isAll: 1,
      }
      try {
        NodeLockPannelService.getBrfBookingLog(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log('BrfBookingList', data)
            if (status == 200 && data) {
              this.BrfBookingList = data.data;
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on getBRFBookingLogDetails Error: ", error);
          });

      } catch (error) {
        console.error("Error updating getBRFBookingLogDetails:", error);
      }
    },
    async toggleStatus(prbr_id, prbr_is_active, booking_id, isbookingactive, request_type) {
      this.isLoading = true;
      console.log("toggleStatus", prbr_id, prbr_is_active, booking_id, isbookingactive, request_type);
      const payload = {
        prbr_id,
        prbr_is_active,
        booking_id,
        isbookingactive,
        request_type,
      };

      try {
        NodeLockPannelService.updateBRFBookingStatus(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.alert.content = data.MSG;
              // this.$refs["addPop"].open();
              this.$emit("success"); // Notify parent to refresh data
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on updateBRFBookingStatus Error: ", error);
          });

      } catch (error) {
        console.error("Error updating updateBRFBookingStatus:", error);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// ToggleBRFSwitch.vue?62958342